import React from 'react';
import '../blocks/ModernBlocks.css';

const ServicesWithImagesBlock = ({ data }) => {
  return (
    <section className="services-with-images-section">
      <div className="services-with-images-container">
        <div className="services-with-images-header">
          <div className="services-with-images-header-content">
            <h2 className="services-with-images-title">{data.title}</h2>
            <p className="services-with-images-subtitle">{data.subtitle}</p>
          </div>
        </div>
        
        <div className="services-with-images-grid">
          {data.items.map((service, index) => (
            <div key={index} className="service-with-image-card">
              <div className="service-with-image-image-wrapper">
                <div className="service-with-image-image">
                  <img src={service.image} alt={service.title} />
                  <div className="service-with-image-overlay">
                    <div className="service-with-image-overlay-content">
                      <div className="service-with-image-overlay-icon">
                        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M9 18L15 12L9 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </div>
                      <h3 className="service-with-image-overlay-title">{service.title}</h3>
                      <p className="service-with-image-overlay-description">{service.description}</p>
                      <a href={service.link} className="service-with-image-link">
                        <span>Learn More</span>
                        <svg className="service-with-image-arrow" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </a>
                    </div>
                  </div>
                </div>
                <div className="service-with-image-badge">
                  <span>Service {index + 1}</span>
                </div>
              </div>
              
              <div className="service-with-image-content">
                <div className="service-with-image-content-header">
                  <h3 className="service-with-image-title">{service.title}</h3>
                  <div className="service-with-image-icon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M2 17L12 22L22 17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M2 12L12 17L22 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>
                </div>
                <p className="service-with-image-description">{service.description}</p>
                <a href={service.link} className="service-with-image-button">
                  <span>Explore Service</span>
                  <svg className="service-with-image-button-arrow" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesWithImagesBlock; 